import type { OtbnAreas } from '../../types/apiModels'
import { apiClient } from './client'
import endpoints from './endpoints'
import type { ApiV2QueryType } from './types'
import { unwrapSingle } from './normalize'

export type OtbnAreasQuery = ApiV2QueryType<{ includeType?: number }>

export default async function getOtbnAreas({
  farmId,
  query,
  signal,
}: {
  farmId: string
  query?: OtbnAreasQuery
  signal?: AbortSignal
}): Promise<OtbnAreas> {
  const response = await apiClient.get(endpoints.v2.farms.otbn(farmId), { params: query, signal })
  return unwrapSingle<OtbnAreas>(response)
}
